import { cloneDeep, isEmpty} from 'lodash';
import { exportToCSV } from '@shared/utils/export.utils';

export class SummaryTableController {
  exportToCSV() {
    let csvContent = 'Bet Type,Profit,Turnover,Valid TO,Bet Count,Win,Loss,Push,Void,Ave.Odds,Yield%\n';
    let details = cloneDeep(this.betOverviewDetails);

    for (let key in details.betOverview) {
      let row = details.betOverview[key];
      csvContent += `${row.betType},"${row.profit}","${row.turnover}","${row.validTurnover}",${row.numberOfBets},${row.winCount},${row.lossCount},${row.pushCount},${row.voidCount},"${row.averageOdds}","${row.yield}"\n`;
    }

    let totals = details.total;
    csvContent += `Total,"${totals.profit}","${totals.turnover}","${totals.validTurnover}",${totals.numberOfBets},${totals.winCount},${totals.lossCount},${totals.pushCount},${totals.voidCount},"${totals.averageOdds}","${totals.yield}"\n`;

    exportToCSV(csvContent, 'betoverview.csv');
  }

  hasResult() {
    if (this.betOverviewDetails && !isEmpty(this.betOverviewDetails.total)) {
      return true;
    }

    return false;
  }
}

export default SummaryTableController;



// WEBPACK FOOTER //
// ./client/app/pages/customer/betoverview/component/overview/component/summarytable.controller.js